import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import { Button } from "@material-ui/core";
import Table from "components/UpdateUi/Table/Table";

import InputLabel from "@material-ui/core/InputLabel";

import { parseDate } from "utils/Utils";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { validate } from "utils/Validator";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import { textFormat } from "utils/Utils";
import { Grid, TableContainer } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import CustomDateField from "components/CustomDateSelector/CustomDateField";
import { loanApplicationStatus } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
import { deviationTableColumns } from "assets/properties/properties";
import { parseDateTimeMDY } from "utils/Utils";
import { getDeviationCodes } from "utils/Utils";
const style = () => ({
  selectContainer: {
    display: "block",
    "& .MuiFormControl-root": {
      "& .MuiInput-underline:before": {
        content: "inherit",
      },
      "& .MuiInput-underline.Mui-focused:after": {
        transform: "inherit",
        borderBottom: "inherit",
      },
      "& .MuiSelect-select.MuiSelect-select": {
        padding: "6px 10px",
        borderRadius: "5px",
        border: "1px solid gray",
        textAlign: "left",
      },
    },
  },
  dateSelector: {
    marginTop: "27px",
  },
  buttonContainer: {
    textAlign: "right",
    "@media (max-width:600px)": {
      textAlign: "center",
    },
  },
  nextButton: {
    padding: "0px 40px",
    letterSpacing: "1px",
  },
  nextButton1: {
    padding: "0px 40px",
  },
});
const Decision = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumber,
  editable,
  closeModal,
  status,
  classes,
  featureFlags,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const outletData = featureFlags;
  const [tableColumns] = useState([
    { id: "Decission_date", label: "Decision Date" },
    { id: "created_by", label: "Created By" },
    { id: "reason", label: "Reason" },
    { id: "remarks", label: "Remarks" },
    { id: "decision", label: "Decision" },
  ]);
  const [collateralTable] = useState([
    { id: "label", label: "Sr. No." },
    { id: "name", label: "Name" },
    { id: "role", label: "Role" },
    { id: "date", label: "Approval Date" },
    { id: "status", label: "Status" },
    { id: "remarks", label: "Remarks" },
  ]);
  const [decisionList] = useState(["APPROVED", "REJECTED", "SENDBACK"]);
  const [reasonList] = useState([
    "Case ok",
    "Customer Denied to take Loan",
    "Gold Or Document Not Proper",
    "Other",
  ]);
  const [tableData, setTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [decision, setDecision] = useState("");
  const [decisionState, setDecisionState] = useState(false);
  const [sanctionDate, setSanctionDate] = useState(new Date());
  const [reason, setReason] = useState("");
  const [reasonState, setReasonState] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [rawData, setRawData] = useState({});
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [collateralApprovalData, setCollateralApprovalData] = useState([]);
  const [deviationApprovalData, setDeviationApprovalData] = useState([]);
  const [showDeviationTable, setShowDeviationTable] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const formatDate = (date) => {
    const newdate = new Date(date);
    const yy = newdate.getFullYear();
    const mm =
      (newdate.getMonth() + 1 < 10 ? "0" : "") + (newdate.getMonth() + 1);
    const dd = (newdate.getDate() < 10 ? "0" : "") + newdate.getDate();
    return yy + "-" + dd + "-" + mm;
  };
  //loan-service/v1/loan/application/decision/add
  useEffect(() => {
    if(loanApplicationId){
    GetDecisionDetails();}
  }, [loanApplicationId]);

  useEffect(() => {
    if (loanApplicationId) {
      getApprovalHistory();
    }
  }, [loanApplicationId]);
  useEffect(() => {
    if (loanApplicationId) {
      getDeviationHistoryData();
    }
  }, [loanApplicationId]);

  const getApprovalHistory = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url:
        endpoint.COLLATERAL_EVALUATION_HISTORY +
        loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!res?.data?.error_code) {
      // setCollateralApprovalData(res?.data);
      let reportData = [];
      res.data &&
        res.data?.forEach((decisionDetails, index) => {
          let row = {
            label: index + 1,
            name: decisionDetails?.name,
            role: decisionDetails?.role,
            date: parseDate(decisionDetails?.approvalDate),
            status: decisionDetails?.status,
            remarks: decisionDetails?.remarks,
          };
          reportData.push(row);
        });

      setCollateralApprovalData(reportData);
    }
  };
   const getDeviationHistoryData = async () => {
      const result = await apiHandler({
        url: endpoint.DEVIATION_HISTORY + loanApplicationId,
        method: "GET",
        authToken,
      });
  
      if (!result?.data || result?.data?.length === 0) return;
  
      const reportData = result?.data;
      let tableRows = [];
      reportData?.forEach((record) => {
        const status = record?.status;
        const approvalUsers = record?.userBasicDetailResponse?.adminUserMap || {};
        const approvedByEmail = record?.approvedBy;
        const deviationCodes = getDeviationCodes(record.deviationJson);
        let approvedStatus =
          status === "REALIZED"
            ? "Approved"
            : status === "REJECTED"
            ? "Rejected"
            : status === "SENDBACK"
            ? "Send Back"
            : "Pending";
        const allUsers = Object.values(approvalUsers).flat();
        if (status === "ENTERED") {
          Object.keys(approvalUsers).forEach((designation) => {
            const users = approvalUsers[designation] || [];
            const names = users.map((u) => u.name).join(", ");
  
            tableRows.push({
              name: names || "N/A",
              hierarchyCode: designation,
              approved: "Pending",
              date: "N/A",
              remarks: "N/A",
              deviationCode: deviationCodes,
            });
          });
        }
        else {
          const approvedUser = allUsers.find(
            (u) => u.username === approvedByEmail || u.email === approvedByEmail
          );
  
          tableRows.push({
            name: approvedUser?.name || approvedByEmail || "N/A",
            hierarchyCode: approvedUser?.designation || "N/A",
            date: parseDateTimeMDY(record.reviewedDate) || "N/A",
            remarks: record.remarks || "N/A",
            deviationCode: deviationCodes,
            approved: approvedStatus,
          });
        }
      });
  
      setDeviationApprovalData(tableRows);
      setShowDeviationTable(true);
    };

  const GetDecisionDetails = async () => {
    const result = await apiHandler({
      url: endpoint.DECISION + loanApplicationId,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      if (!editable) {
        setRawData(result?.data?.[0]);
        setDecision(result?.data?.[0]?.decision);
        setSanctionDate(result?.data?.[0]?.sanctionedDate);
        // setSanctionExpiryDate(result?.data?..sa?nctionExpiryDate);
        setReason(result?.data?.[0]?.reason);
        setRemarks(textFormat(result?.data?.[0]?.remarks));
      }
      if (result?.data?.length === 0) {
        setShowTable(false);
      } else {
        setShowTable(true);
      }
      // if(result?.data?.length > 0 || result.data || typeOf result?.data?.length !== 'undefined'){
      let reportData = [];
      result.data &&
        result.data?.forEach((decisionDetails, index) => {
          let row = {
            Decission_date: decisionDetails?.sanctionedDate,
            created_by: decisionDetails?.createdBy,
            reason: decisionDetails?.reason,
            remarks: decisionDetails?.remarks,
            decision: decisionDetails?.decision,
          };
          reportData.push(row);
        });

      setTableData(reportData);
    }
  };
  const isValidated = () => {
    if (decision === "") {
      setDecisionState(true);
    } else {
      setDecisionState(false);
    }
    if (reason === "") {
      setReasonState(true);
    } else {
      setReasonState(false);
    }
    if (
      decision &&
      decision !== "" &&
      sanctionDate &&
      sanctionDate !== null &&
      reason &&
      reason !== "" &&
      remarks &&
      remarks !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  const change = (
    event,
    stateName,
    validState,
    errorState,
    rules,
    errorData
  ) => {
    const errorObj = validate(event.target.value, rules, errorData);
    stateName(event.target.value);
    errorState && errorState(errorObj);
    validState && validState(errorObj.length ? "error" : "success");
  };
  const handlecreateuserSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    //setNext();
    //  props.navigate(`/admin/document/` + params.loanApplicationId);
    if (decision === "" || typeof decision === "undefined") {
      setDecisionState(true);
    }
    if (reason === "" || typeof reason === "undefined") {
      setReasonState(true);
    }
    if (decision === "REJECTED") {
      UnAssignPacketNumber();
    }
    if (status === "FORAPPROVAL") {
      if (isValidated()) {
        //DECISION_ADD
        setCallInProgress(true);
        const res = await apiHandler({
          url: endpoint.DECISION_ADD,
          method: "POST",
          authToken: authToken,
          data: {
            loanApplicationId: loanApplicationId,
            decision: decision && decision !== "" ? decision : null,
            sanctionedDate: parseDate(sanctionDate),
            //sanctionExpiryDate: parseDate(sanctionExpiryDate),
            reason: reason && reason !== "" ? reason : null,
            remarks: remarks && remarks !== "" ? textFormat(remarks) : null,
          },
        });
        setCallInProgress(false);
        if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          return;
        } else {
            navigate("/loanservice/approval", { state: { from: '' } });
        }
      } else {
        toastUpdate("Error", "Please Provide the Decision Details", true);
  
      }
    } else {
      setNext();
    }
  };

  const UnAssignPacketNumber = async (getPacketNumber) => {
    const res = await apiHandler({
      url: endpoint.UNASSIGN_PACKETS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    if (res?.data) {
      return true;
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    setBack();
    //props.history.go(-1);
  };
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };
  const handleDateChange = (date) => {
    setSanctionDate(date);
  };
   const handleClose=()=>{

      if(status === loanApplicationStatus?.disburseToLms) {
           navigate("/loanservice/disbursLms", { state: { from: "" } });
         } else if(status === loanApplicationStatus?.completed) {
           navigate("/loanservice/completed", { state: { from: "" } });
         }else if(status === loanApplicationStatus?.rejected) {
           navigate("/loanservice/rejected", { state: { from: "" } });
         } else if(status === loanApplicationStatus?.discrepancy) {
           navigate("/loanservice/discrepancyApproval", { state: { from: "" } });
         } else {
           console.log("Handle other status or just close modal");
         }
    }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
           label={headerLabel?.descisionDetail}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
            onlyLabel/>
      </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
        <CustomSelectNew
          label="Decision*"
          error={decisionState}
          value={decision || ""}
          setState={setDecision}
          data={decisionList}
          disabled={!editable}
          setError={setDecisionState}
          id="decision"
        />
      </Grid>
       <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomDateField
             onChange={handleDateChange}
             value={sanctionDate ? sanctionDate : null}
             label="Sanction Date"
             disabled= {!editable}
             maxDate={new Date()}
           />
        </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
        <CustomSelectNew
          label="Reason*"
          error={reasonState}
          value={reason || ""}
          setState={setReason}
          data={reasonList}
          disabled={!editable}
          setError={setReasonState}
          id="reason"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
        <textarea
          placeholder="Remarks"
          onChange={(e) => (editable ? setRemarks(e.target.value) : null)}
          value={textFormat(remarks)}
          disabled={!editable}
          required
          id="remarks"
          style={{ width: "100%", borderRadius: "5px" }}
        />
      </Grid>

      {status === "FORAPPROVAL" ? (
        <GridContainer style={{ flexDirection: "row" }}>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.buttonContainer}
            style={{
              textAlign: window.innerWidth <= 600 ? "center" : "right",
            }}
          >
            <Button
              size="small"
              onClick={() => handlecanceluser()}
              className={classes.nextButton1}
            >
              Back
            </Button>
            <Button
              size="small"
              className={classes.nextButton}
              disabled={callInProgress}
              onClick={(event) => handlecreateuserSubmit(event)}
            >
              submit
            </Button>
          </GridItem>
        </GridContainer>
      ) : (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            className={classes.buttonContainer}
            style={{
              textAlign: window.innerWidth <= 600 ? "center" : "right",
            }}
          >
            <Button
              style={{ margin: "5px" }}
              size="small"
              className={classes.nextButton1}
              onClick={() => back()}
            >
              Back
            </Button>
            <Button
              style={{ margin: "5px" }}
              size="small"
              className={classes.nextButton}
              onClick={() =>
                status === "REJECTED" ?handleClose() : handlenext()
              }
            >
              {status === "REJECTED" ? "Close" : "Next"}
            </Button>
          </GridItem>
        </GridContainer>
      )}
       {showDeviationTable && deviationApprovalData.length > 0 && (
          <GridContainer>
              <SubHeader
           label="Deviation History"
         />
            <TableContainer>
              <Table columns={deviationTableColumns} rows={deviationApprovalData} styles="style"/>
            </TableContainer>
          </GridContainer>
        )}
      {collateralApprovalData.length > 0 && status === "FORAPPROVAL" && 
      <GridContainer>
        <Grid
          style={{
            margin: "0px 15px 15px",
            fontWeight: "700",
            fontSize: "24px",
          }}
        >
          <span> Valuation Approval History</span>
        </Grid>
        <TableContainer>
          <Table
            columns={collateralTable}
            rows={collateralApprovalData}
            styles="style"
            noPagination
          />
        </TableContainer>
      </GridContainer>}
      {showTable && (
        <GridContainer>
          <Grid
            style={{
              margin: "30px 15px 15px",
              fontWeight: "700",
              fontSize: "24px",
            }}
          >
            <span> Credit Approval History</span>
          </Grid>
          <TableContainer>
            <Table
              columns={tableColumns}
              rows={tableData}
              styles="style"
              noPagination
            />
          </TableContainer>
        </GridContainer>
      )}
     {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

Decision.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
  loanApplicationNumber: PropTypes.object,
  status: PropTypes.object,
};

export default withStyles(style)(Decision);
